import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-logout',
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<p>Cerrando sesión...</p>`,
})
export class LogoutComponent implements OnInit {
  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private authService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    // 1. Llamar al método centralizado de logout que limpia carrito, sesión y notifica el estado
    this.authService.logout();

    // 2. Notificar al usuario
    this.notificationService.showSuccess(
      'Sesión Cerrada',
      'Has cerrado sesión correctamente.',
    );

    // 3. Redirigir a la página de inicio
    this.router.navigate(['/']);
  }
}
